import { Lender } from './Lender';
import { LenderTierHeader } from './LenderTierHeader';
import { classNames } from '@axo/shared/util/dom';
import styles from './Lender.module.css';
import { AvailableLender } from '../IAvailableLenders';
import { MarketCountryCode } from '@axo/shared/types';

const MAX_ROWS_PER_COLUMN = 6;

interface LendersForTierProps {
  applicationID: string;
  lenders: AvailableLender[];
  tier: string;
  marketCountry: MarketCountryCode;
}

export function LendersForTier({
  applicationID,
  lenders,
  tier,
  marketCountry,
}: LendersForTierProps) {
  return (
    <div className={styles.lenderColumnsContainer}>
      <LenderTierHeader tier={tier} lenders={lenders} />
      <div className={styles.lenderItemsColumns}>
        {lenders.map((lender, i) => (
          <div
            className={classNames(
              styles.lenderItem,
              i < MAX_ROWS_PER_COLUMN && styles.firstColumn,
            )}
            key={lender.lenderID}
          >
            <Lender
              applicationID={applicationID}
              lender={lender}
              marketCountry={marketCountry}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
